module.exports = __webpack_public_path__ + "img/836235.8e386900.jpg";